
<div class="grid grid-2x grid-gap-20">
  <div>
    <h5 class="head">Existing</h5>
  </div>
  <div>
    <h5 class="head" style="color:darkolivegreen">New</h5>
  </div>
</div>

<div *ngIf="'address'==formType">
  <div class="grid grid-2x grid-gap-0"> <!-- grid-gap must be 0 for ADDRESS alone -->
    <!-- Existing-->
    <div class="inputs-are-disabled">
      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Address Line 1, 2, 3</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 1" name="input-basic" value="505, Redwood Lane"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 2" name="input-basic" value="Near Dalal Street"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 3" name="input-basic" value="North "/>
          </nz-form-control>
        </nz-form-item>
        <!-- 3 -->
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">PIN Code</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input placeholder="PIN" name="input-basic" style="width: 100%" value="400045"/>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Country</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch [ngModel]="'India'" style="width: 100%">
                  <nz-option [nzLabel]="'India'" [nzValue]="'India'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">State</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch [ngModel]="'Maharashtra'" style="width: 100%">
                  <nz-option [nzLabel]="'Maharashtra'" [nzValue]="'Maharashtra'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">City</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch [ngModel]="'Mumbai'" style="width: 100%">
                  <nz-option [nzLabel]="'Mumbai'" [nzValue]="'Mumbai'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

    </div>

    <!-- New -->
    <div>
      <div>
        <div class="form-secondary-fields p-l-r-20 p-t-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Address Line 1, 2, 3</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Address Line 1" name="input-basic"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Address Line 2" name="input-basic"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Address Line 3" name="input-basic"/>
            </nz-form-control>
          </nz-form-item>
          <!-- 3 -->
          <div class="flexie-auto-grid">
            <div>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">PIN Code</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="PIN" name="input-basic" style="width: 100%"/>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Country</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select nzShowSearch [ngModel]="'India'" style="width: 100%">
                    <nz-option [nzLabel]="'India'" [nzValue]="'India'"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="flexie-auto-grid">
            <div>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">State</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select nzShowSearch [ngModel]="'Maharashtra'" style="width: 100%">
                    <nz-option [nzLabel]="'Maharashtra'" [nzValue]="'Maharashtra'"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">City</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select nzShowSearch [ngModel]="'Mumbai'" style="width: 100%">
                    <nz-option [nzLabel]="'Mumbai'" [nzValue]="'Mumbai'"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div *ngIf="'email'==formType">
  <div class="grid grid-2x grid-gap-20">
    <!-- Existing-->
    <div class="inputs-are-disabled">
      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Email ID</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Email ID" name="input-basic" value="smet2001@yahoo.co"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- New -->
    <div>
      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Email ID</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Email ID" name="input-basic" value=""/>
          </nz-form-control>
        </nz-form-item>
    </div>
  </div>
</div>
</div>


<div *ngIf="'name'==formType">
  <div class="grid grid-2x grid-gap-20">
    <!-- Existing -->
    <div class="inputs-are-disabled grid grid-2x grid-gap-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">First Name</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input value="Jay"/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input value="Mehta"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <!-- NEW -->
    <div class="grid grid-2x grid-gap-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">First Name</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input value=""/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input value=""/>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</div>



<div *ngIf="'dob'==formType">
  <div class="grid grid-2x grid-gap-20">
    <!-- Existing -->
    <div class="inputs-are-disabled">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker style="width:100%" [nzFormat]="'DD MMM YYYY'" [ngModel]="'1978-11-20'"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <!-- NEW -->
    <div>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker style="width:100%" [nzFormat]="'DD MMM YYYY'"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</div>

<div *ngIf="'pin'==formType">
  <div class="grid grid-2x grid-gap-20">
    <!-- Existing -->
    <div class="inputs-are-disabled">
      <div class="flexie-auto-grid">
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">PIN Code</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="PIN" name="input-basic" style="width: 100%" value="400045"/>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Country</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'India'" style="width: 100%">
                <nz-option [nzLabel]="'India'" [nzValue]="'India'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="flexie-auto-grid">
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">State</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'Maharashtra'" style="width: 100%">
                <nz-option [nzLabel]="'Maharashtra'" [nzValue]="'Maharashtra'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">City</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'Mumbai'" style="width: 100%">
                <nz-option [nzLabel]="'Mumbai'" [nzValue]="'Mumbai'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
    <!-- NEW -->
    <div>
      <div class="flexie-auto-grid">
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">PIN Code</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="PIN" name="input-basic" style="width: 100%" value=""/>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Country</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'India'" style="width: 100%">
                <nz-option [nzLabel]="'India'" [nzValue]="'India'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="flexie-auto-grid">
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">State</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'Maharashtra'" style="width: 100%">
                <nz-option [nzLabel]="'Maharashtra'" [nzValue]="'Maharashtra'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">City</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [ngModel]="'Mumbai'" style="width: 100%">
                <nz-option [nzLabel]="'Mumbai'" [nzValue]="'Mumbai'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </div>
</div>

<!--
  ::template::
  <div class="grid grid-2x grid-gap-20">
    <div class="inputs-are-disabled">
    </div>
    <div>
    </div>
  </div>
-->
